/*********************************************************************************************
* Initialize the sticky CTA behavior.
	* 
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');

	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				// Si le CTA principal n'est plus visible
				stickyCTA.classList.remove('mm-none');
			} else {
				// Si le CTA principal est visible
				stickyCTA.classList.add('mm-none');
			}
		});
	}, {
		root: null, // viewport par défaut
		threshold: 0 // détecter si n'importe quelle partie de l'élément est visible
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputKey) {
	const inputs = document.querySelectorAll(`[data-qtty-input="${inputKey}"]`);
	const plusBtns = document.querySelectorAll(`[data-qtty-plus="${inputKey}"]`);

	if (!inputs.length) return;

	let currentValue = parseInt(inputs[0].value, 10) || 1;
	let max = inputs[0].max ? parseInt(inputs[0].max, 10) : Infinity;

	if (delta === -1 && currentValue === 1) return;

	let newValue = currentValue + delta;
	if (newValue < 1) newValue = 1;
	if (newValue >= max) {
		newValue = max;
		plusBtns.forEach(btn => btn.setAttribute("disabled", "true"));
	} else {
		plusBtns.forEach(btn => btn.removeAttribute("disabled"));
	}

	// Mettre à jour tous les inputs liés
	inputs.forEach(input => input.value = newValue);

	// Mise à jour des prix en fonction de la nouvelle quantité
	mmUpdatePrice(newValue);
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");
	var currencySymbol = document.body.dataset.currency;

	function formatNumber(value) {
		// Supprime les .00 mais garde les autres décimales
		return Number.isInteger(value) ? value : value.toFixed(2);
	}

	function formatPrice(symbol, value) {
		const formattedValue = formatNumber(value);
		if (symbol === "£" || symbol === "$") {
			return symbol + formattedValue;
		} else {
			return formattedValue + symbol;
		}
	}

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			var total = (priceValue * qtty) / 100;
			price.innerHTML = formatPrice(currencySymbol, total);
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			var total = (comparePriceValue * qtty) / 100;
			comparePrice.innerHTML = formatPrice(currencySymbol, total);
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
* Class for handling variant selection
	* 
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest(".mm-main-product");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		* 
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
                // this.updateImagesVariant();
            } else {
                // this.updateMedia();
            }
            this.variantFetch();
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

/*********************************************************************************************
    * Render variant information in the DOM.
        *
        * @param {Document} html - The HTML document containing the variant information.
    */
    renderVariantInfo(html) {
        this.updateMultipleElement(".mm-reload", html);
        
        // Add this line to handle updating slide configurations alongside your new badge
        this.updateMedia(); 
    }

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = this.container.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination) {
            for (let index = 0; index < source.length; index++) {
                destination[index].outerHTML = source[index].outerHTML;
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media) {
            var variant_media_id = this.currentVariant.featured_media.id;
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

            allMainMedia.forEach((media, index) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    splideMainInstance.go(index);
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	// initializeStickyCTA();

});

/*********************************************************************************************
 * Splide Collection Search - Initialisation
 *
 */
function initializeSplideRelatedProduct(splideElem) {
    var splideInstance = new Splide(splideElem, {
			type        : 'slide',
			arrows      : true,
			pagination  : false,
			fixedWidth  : 'fit-content',
			omitEnd     : true,
			gap         : '8px',
			breakpoints: {
				768: {
					perPage		: 1,
					perMove		: 1
				}
			}
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Splide reassurance - Initialisation
 *
 */
function initializeSplideReassurance(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'loop',
        arrows      : false,
        pagination  : true,
        perPage     : 1,
        drag        : 'free',
        snap        : true,
        fixedWidth  : '100%',
        autoplay    : true,
        interval    : 4000, 
        pauseOnHover: false,
        breakpoints : {
            768: {
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Splide Media - Initialisation
 *
 */
function initializeSplideMedia(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : true,
        perPage     : 1,
        fixedWidth  : '90%',
		destroy		: true,
        breakpoints : {
            1024: {
				destroy		: false
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Media thumbnails - Initialisation
 *
 */
function initializeMediaThumbnails() {
	const thumbnails = document.querySelectorAll('.mm-product-medias-thumbnail');
	if (!thumbnails.length) return;

	thumbnails.forEach(thumbnail => {
		thumbnail.addEventListener('click', function (e) {
			e.preventDefault();

			// Supprimer la classe mm-active de toutes les thumbnails
			thumbnails.forEach(t => t.classList.remove('mm-active'));

			// Ajouter mm-active à la thumbnail cliquée
			this.classList.add('mm-active');

			// Scroll avec offset vers l'élément ciblé
			const targetId = this.getAttribute('href').replace('#', '');
			const target = document.getElementById(targetId);

			if (target) {
				const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height')) + 20;
				const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

				window.scrollTo({
					top: targetPosition,
					behavior: 'smooth'
				});
			}
		});
	});
}

// Ouvrir la modale
function mmOpenInfoEngraving() {
	const modalSurface = document.querySelector(".mm-product-form-engraving-modale");
	modalSurface.classList.add("mm-modal-is-open-engraving");
	document.querySelector("html").classList.add("stop-scrolling");
}
// Fermer la modal
function mmCloseInfoEngraving() {
	const modalSurface = document.querySelector(".mm-product-form-engraving-modale");
	const modalBg = document.querySelector(".mm-modal-bg-engraving");

	document.querySelector(".mm-product-form-engraving-modale").classList.remove("mm-modal-is-open-engraving");
	document.querySelector("html").classList.remove("stop-scrolling");

	modalSurface.classList.remove("mm-modal-is-open-engraving");
}
document.addEventListener("DOMContentLoaded", () => {
	const engravingModal = document.querySelector(".mm-product-form-engraving-modale");
	if (engravingModal) {
		engravingModal.addEventListener("mouseleave", mmCloseInfoEngraving);
	}
});


/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	initializeSectionsWithSplide('data-section-main-product', '.mm-related-products-splide', initializeSplideRelatedProduct);
	initializeSectionsWithSplide('data-section-main-product', '.mm-product-form-variant-splide', initializeSplideRelatedProduct);
	initializeSectionsWithSplide('data-section-main-product', '.mm-product-form-reassurance-splide', initializeSplideReassurance);
	initializeSectionsWithSplide('data-section-main-product', '.mm-product-medias-main-splide', initializeSplideMedia);
	initializeMediaThumbnails();
});

window.addEventListener('resize', () => {
	initializeSectionsWithSplide('data-section-main-product', '.mm-related-products-splide', initializeSplideRelatedProduct);
	initializeSectionsWithSplide('data-section-main-product', '.mm-product-form-variant-splide', initializeSplideRelatedProduct);
});

function initializeCITESModal() {
    const modal = document.getElementById('cites-popup-modal');
    const trigger = document.getElementById('atc-modal-trigger');
    const closeBtn = document.getElementById('cites-close-btn');
    const confirmBtn = document.querySelector('.cites-atc-btn');
    const productForm = document.getElementById('product-form');

    if (!modal || !trigger) return;

    // Show modal when clicking the fake ATC button
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    });

    const hide = () => { 
        modal.style.display = 'none'; 
        document.body.style.overflow = ''; 
    };

    closeBtn.addEventListener('click', hide);
    
    // Close on background click
    modal.addEventListener('click', (e) => { if (e.target === modal) hide(); });

    // Handle the actual submission
    confirmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // This triggers the native form submission or your AJAX add-to-cart
        productForm.submit(); 
    });
}

// Add to your DOMContentLoaded listener
document.addEventListener("DOMContentLoaded", () => {
    initializeCITESModal();
    // ... your other initializers
});